module.exports = __webpack_public_path__ + "img/logo-perama.943c9eec.jpg";